<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<!-- 		<el-radio-group v-model="radio" size="mini" style="margin-bottom: 10px;" @change="dimensionChange">
			<el-radio-button :label="2">客服维度</el-radio-button>
			<el-radio-button :label="1">店铺维度</el-radio-button>			
		</el-radio-group> -->
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="settlementtasklist"
			collapse @item-click="itemClick" :klass="klass" v-if="settlementtasklist.length!=0" :item-events="itemEvents"></v-jstree>

	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {
			sourceData: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				loading: false,
				settlementtasklist: [],
				settlementtasksource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				klass: '',
				currentChildren: [],
				radio: 2,
				itemEvents: {
					mouseover: (e) => {
						this.currentItem = e.model
						this.klass = 'menuoverClass'

					},
					mouseleave: () => {
						//console.log(e.model)
						this.klass = ''
					},
					// contextmenu: (component, model, event) => {
					// 	this.onContextmenu(event, model)
					// 	event.preventDefault()
					// }
				},
			}
		},
		created() {
			this.init()
			//this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			onContextmenu(event, model) {
				console.log(model)
				let items = [{
					label: "kpi配置",
					disabled: model.type!='department' && model.type!='total',
					onClick: () => {
						this.addNode()
					}
				}, {
					label: "业绩转移",
					disabled: model.type!='staff',
					onClick: () => {
						this.editNode()
					}
				}]
				this.$contextmenu({
					items: items,
					event,
					customClass: "custom-class",
					zIndex: 9999999,
					minWidth: 150
				});
				return false;
			},
			dimensionChange() {
				this.settlementtasklist = []
				this.$nextTick(() => {
					this.init()
				})
			},
			init() {
				let data = []
				let groupBydepartment = []
				let groupBypsnNickName = []
				let treeData = [{
					id: "total",
					type:'total',
					parent: "#",
					name: '全部',
					children: []
				}];
				if (this.radio == 1) {
					data = this.$Lodash.sortBy(this.sourceData, 'shopname')
					groupBydepartment = this.$Lodash.groupBy(this.sourceData, 'shopname')
					groupBypsnNickName = this.$Lodash.mapValues(groupBydepartment, group => this.$Lodash.groupBy(group,
						'departmentid'))
					data = this.$Lodash.mapValues(groupBypsnNickName, departmentGroup =>
						this.$Lodash.mapValues(departmentGroup, psnNickNameGroup => this.$Lodash.groupBy(
							psnNickNameGroup,
							'psnNickName'))
					);
				}
				if (this.radio == 2) {
					data = this.$Lodash.sortBy(this.sourceData, 'departmentid')
					groupBydepartment = this.$Lodash.groupBy(this.sourceData, 'departmentid')
					groupBypsnNickName = this.$Lodash.mapValues(groupBydepartment, group => this.$Lodash.groupBy(group,
						'psnNickName'))
					data = this.$Lodash.mapValues(groupBypsnNickName, departmentGroup =>
						this.$Lodash.mapValues(departmentGroup, psnNickNameGroup => this.$Lodash.groupBy(
							psnNickNameGroup,
							'shopname'))
					);
				}
				this.settlementtasksource = data

				this.$Lodash.forEach(data, (departmentGroup, departmentId) => {
					let departmentNode = {
						id: departmentId,
						parent: 'total',
						name: this.radio == 2 ? this.$systemMethods.getdepartment(departmentId) : departmentId,
						type: this.radio == 1 ? 'shop' : 'department',
						children: []
					}
					this.$Lodash.forEach(departmentGroup, (psnNickNameGroup, psnNickName) => {
						let personNode = {
							id: psnNickName,
							parent: departmentId,
							name: psnNickName,
							opened: false,
							type: this.radio == 1 ? 'department' : 'staff',
							children: []
						}
						this.$Lodash.forEach(psnNickNameGroup, (shopGroup, shopname) => {
							let shopNode = {
								id: shopname,
								parent: psnNickName,
								name: shopname,
								type: this.radio == 1 ? 'staff' : 'shop',
								children: []
							};
							personNode.children.push(shopNode)
						});
						departmentNode.children.push(personNode)
					});
					treeData[0].children.push(departmentNode)
				});

				console.log(data)

				this.settlementtasklist = treeData
			},
			itemClick(node, item, e) {

				console.log(node)
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentid: item.parent,
					childrenid: item.children,
					type: item.type,
					node: node

				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			timestampToYear(timestamp) {
				let date = new Date(timestamp)
				let year = date.getFullYear()
				return year
			}
		},
		components: {
			VJstree
		}
	}
</script>